import React, { useEffect, useState } from "react"
import SharedFacebook from "../../../shared/components/atoms/shared-facebook/shared-facebook"
import SharedWhatsapp from "../../../shared/components/atoms/shared-whatsapp/shared-whatsapp"
import StandardModal from "../../../shared/components/modals/standard-modal/standard-modal"
import MagazineService from "../../../shared/services/magazine"
import NotificationService from "../../../shared/services/notification-service"
import { siteUrl } from "../../../shared/utils/siteUrl"
import "./interaction-article-mg.scss"

const InteractionArticleMG = props => {
  const {
    idArticle,
    item,
    handleSave,
    handleUnSave,
    savedArticles,
    updatedAt,
    isLog,
    setModalState,
    interactDatalayer = () => {},
  } = props

  const [activeShareMenu, setShareMenu] = useState(false)
  const [likesTooltip, setlikesTooltip] = useState(100)
  const [localLikes, setlocalLikes] = useState([])
  const [fakeLikes, setfakeLikes] = useState(false)
  const [fakeUnLikes, setfakeUnLikes] = useState(false)
  const [activeNotifications, setactiveNotifications] = useState(false)
  const [linkShared, setactiveLinkShared] = useState("/")

  var payload = {
    id: item.contentful_id,
    titulo: item.metaTitulo,
    descripcion: item.metaDescripcion.metaDescripcion,
    imagen: item.metaImagen,
    categorias: item.categorias,
    slug: "/magazin/nuestro-mundo/" + item.slug,
    imagenCreadorArticulo: item.imagenCreadorArticulo,
    tipoDeArticulo: item.tipoDeArticulo,
    updatedAt: updatedAt,
    nombreCreadorArticulo: item.nombreCreadorArticulo,
    creadorArtculo: item.creadorArtculo,
  }

  useEffect(() => {
    setactiveLinkShared(
      typeof window !== "undefined"
        ? props.mobile
          ? "whatsapp://send?text=" + window.location.href
          : "https://web.whatsapp.com/send?text=" + window.location.href
        : "/"
    )

    if (localStorage.getItem("TOKEN_INFO") !== null) {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }

      NotificationService.notificationsSettings(config)
        .then(res => {
          if (res.status === 200) {
            setactiveNotifications(
              res.data.filter(elem => elem.code === "nuestro_mundo")[0].active
            )
          } else {
            console.log(res)
          }
        })
        .then(e => console.log(e))
    }

    MagazineService.getLikeById(idArticle, process.env.COUNTRY_CODE)
      .then(res => {
        if (res.status === 200) {
          setlikesTooltip(res.data)
        } else {
          console.log(res)
        }
      })
      .catch(e => console.log(e))

    if (localStorage.getItem("TOKEN_INFO") === null) {
      if (localStorage.getItem("LOCAL_ARTICLES_LIKES") !== null) {
        setlocalLikes(JSON.parse(localStorage.getItem("LOCAL_ARTICLES_LIKES")))
      }
    } else {
      if (localStorage.getItem("LOCAL_ARTICLES_LIKES") !== null) {
        localStorage.removeItem("LOCAL_ARTICLES_LIKES")
      }

      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      MagazineService.getLikesArticles(process.env.COUNTRY_CODE, config).then(
        res => {
          // console.log(res)

          if (res.status === 200) {
            localStorage.setItem(
              "LOCAL_ARTICLES_LIKES",
              JSON.stringify(res.data)
            )
            setlocalLikes(res.data)
          } else {
            console.log(res)
          }
        }
      )
    }
  }, [])

  const formatNumberLikes = num => {
    if (num > 99) {
      return "+99"
    } else {
      return num
    }
  }

  const handleLike = idArt => {
    var payload = {
      contentId: idArt,
      country: process.env.COUNTRY_CODE,
      like: true,
    }

    if (localStorage.getItem("TOKEN_INFO") === null) {
      MagazineService.postLikeAnom(payload)
        .then(res => {
          if (res.status === 200) {
            if (localStorage.getItem("LOCAL_ARTICLES_LIKES") === null) {
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify([idArt])
              )
              setlocalLikes([idArt])

              if (fakeUnLikes) {
                setfakeUnLikes(false)
              } else {
                setfakeLikes(true)
              }
            } else {
              var copyLocalStorageLikes = JSON.parse(
                localStorage.getItem("LOCAL_ARTICLES_LIKES")
              )
              var newLikeList = copyLocalStorageLikes.concat([idArt])
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify(newLikeList)
              )
              setlocalLikes(newLikeList)

              if (fakeUnLikes) {
                setfakeUnLikes(false)
              } else {
                setfakeLikes(true)
              }
            }
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }

      MagazineService.postLikeAuth(payload, config)
        .then(res => {
          if (res.status === 200) {
            if (localStorage.getItem("LOCAL_ARTICLES_LIKES") === null) {
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify([idArt])
              )
              setlocalLikes([idArt])

              if (fakeUnLikes) {
                setfakeUnLikes(false)
              } else {
                setfakeLikes(true)
              }
            } else {
              var copyLocalStorageLikes = JSON.parse(
                localStorage.getItem("LOCAL_ARTICLES_LIKES")
              )
              var newLikeList = copyLocalStorageLikes.concat([idArt])
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify(newLikeList)
              )
              setlocalLikes(newLikeList)

              if (fakeUnLikes) {
                setfakeUnLikes(false)
              } else {
                setfakeLikes(true)
              }
            }
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const handleUnLike = idArt => {
    var payload = {
      contentId: idArt,
      country: process.env.COUNTRY_CODE,
      like: false,
    }

    if (localStorage.getItem("TOKEN_INFO") === null) {
      MagazineService.postLikeAnom(payload)
        .then(res => {
          if (res.status === 200) {
            var copyLocalStorageLikes = JSON.parse(
              localStorage.getItem("LOCAL_ARTICLES_LIKES")
            )
            var newLikeList = copyLocalStorageLikes.filter(
              item => item !== idArt
            )
            localStorage.setItem(
              "LOCAL_ARTICLES_LIKES",
              JSON.stringify(newLikeList)
            )
            setlocalLikes(newLikeList)

            if (fakeLikes) {
              setfakeLikes(false)
            } else {
              setfakeUnLikes(true)
            }
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }

      MagazineService.postLikeAuth(payload, config)
        .then(res => {
          if (res.status === 200) {
            var copyLocalStorageLikes = JSON.parse(
              localStorage.getItem("LOCAL_ARTICLES_LIKES")
            )
            var newLikeList = copyLocalStorageLikes.filter(
              item => item !== idArt
            )
            localStorage.setItem(
              "LOCAL_ARTICLES_LIKES",
              JSON.stringify(newLikeList)
            )
            setlocalLikes(newLikeList)

            if (fakeLikes) {
              setfakeLikes(false)
            } else {
              setfakeUnLikes(true)
            }
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const activateNotificationSection = () => {
    if (isLog) {
      var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      var config = {
        headers: {
          Authorization: tokenId,
        },
      }

      let payload = {
        active: true,
        notificationType: "nuestro_mundo",
      }

      NotificationService.activeNotificationSettings(payload, config)
        .then(res => {
          if (res.status === 200) {
            setactiveNotifications(true)
            setModalState(
              <StandardModal
                noButton={true}
                title="Notificaciones activadas"
                description="Ahora recibirás notificaciones de la sección Magazín"
                click={() => setModalState(null)}
                subtitle=""
              />
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      window.location.href = siteUrl + "/login"
    }
  }

  return (
    <div
      className={
        "f-interaction-article f-btn-float-type " +
        (props.mobile && props.scrollValue < 40 && "f-hidden-menu ") +
        (props.mobile && props.scrollValue > 40 && " f-showing-menu")
      }
    >
      <div
        className="f-left-interaction offline-btn"
        onClick={e =>{
          interactDatalayer("save")
          savedArticles.filter(a => a.id === item.contentful_id).length !== 0
            ? handleUnSave(e, item.contentful_id)
            : handleSave(e, payload)
        }}
      >
        {/* <span className="f-icon f-icon-save icon-save"></span> */}
        {savedArticles.filter(a => a.id === item.contentful_id).length !== 0 ? (
          <span className="icon2-guardado-active " />
        ) : (
          <span className="icon-save " />
        )}
        <span className="f-action-title">Guardar</span>
        <span className="f-tooltip-save">
          Guarda este artículo y míralo sin conexión a internet después
          <span className="f-tooltip-signal"></span>
        </span>
      </div>
      <div className="f-right-interaction">
        <div
          className={
            "f-showing-share " + (activeShareMenu && "share-showing-inactive")
          }
        >
          {localLikes.includes(idArticle) ? (
            <span
              className="f-icon icon2-corazon-relleno1 f-heart-full f-icon-heart"
              onClick={() => {
                interactDatalayer("unlike")
                handleUnLike(idArticle)
              }}
            >
              <span className="f-tooltip-heart">
                {formatNumberLikes(
                  fakeLikes
                    ? likesTooltip + 1
                    : fakeUnLikes
                    ? likesTooltip - 1
                    : likesTooltip
                )}
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          ) : (
            <span
              className="f-icon icon-heart f-icon-heart"
              onClick={() => {
                interactDatalayer("like")
                handleLike(idArticle)
              }}
            >
              <span className="f-tooltip-heart">
                {formatNumberLikes(
                  fakeLikes
                    ? likesTooltip + 1
                    : fakeUnLikes
                    ? likesTooltip - 1
                    : likesTooltip
                )}
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          )}
          <span
            className="f-icon icon-share"
            onClick={() => {
              interactDatalayer("share")
              setShareMenu(true)
            }}
          ></span>
          {activeNotifications ? (
            <span className="f-icon icon2-notification-active f-icon-notification" />
          ) : (
            <span
              className="f-icon icon-notification f-icon-notification"
              onClick={() => {
                activateNotificationSection()
                interactDatalayer("notification")
              }}
            >
              <span className="f-tooltip-notification">
                Activa las notificaciones para recibir lo último de magazín
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          )}
        </div>
        <div
          className={
            "f-hidden-share " + (activeShareMenu && "share-hidden-active")
          }
        >
          <SharedFacebook
            href={typeof window !== "undefined" ? window.location.href : "/"}
          >
            <span className="f-icon icon-facebook"></span>
          </SharedFacebook>

          <SharedWhatsapp href={linkShared} />

          <span
            className="f-icon icon2-close f-icon-close"
            onClick={() => setShareMenu(false)}
          ></span>
        </div>
      </div>

      <div
        className={
          "f-btn-float-type f-fixed-interaction " +
          (props.scrollValue > 40 && !props.mobile && "f-fixed-active")
        }
      >
        <div
          className={
            "f-showing-share-fixed " +
            (activeShareMenu && "share-showing-inactive")
          }
        >
          {/* <span className="f-icon f-icon-save-fixed icon-save" onClick={event => { event.preventDefault(); props.setModalState() }}>
                        <span className="f-tooltip-save">
                            {'Guarda este artículo y míralo sin conexión a internet después'}
                            <span className="f-tooltip-signal"></span>
                        </span>
                    </span> */}
          {savedArticles.filter(a => a.id === item.id).length !== 0 ? (
            <span
              className="f-icon f-icon-save-fixed icon2-guardado-active "
              onClick={e => {
                interactDatalayer("unsave")
                handleUnSave(e, item.id)
              }}
            >
              <span className="f-tooltip-save">
                Guarda este artículo y míralo sin conexión a internet después
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          ) : (
            <span
              className="f-icon f-icon-save-fixed icon-save "
              onClick={e => {
                interactDatalayer("save")
                handleSave(e, payload)
              }}
            >
              <span className="f-tooltip-save">
                Guarda este artículo y míralo sin conexión a internet después
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          )}
          {localLikes.includes(idArticle) ? (
            <span
              className="f-icon icon2-corazon-relleno1 f-heart-full f-icon-heart f-icon-heart-fixed"
              onClick={() => {
                interactDatalayer("unlike")
                handleUnLike(idArticle)
              }}
            >
              <span className="f-tooltip-heart">
                {formatNumberLikes(
                  fakeLikes
                    ? likesTooltip + 1
                    : fakeUnLikes
                    ? likesTooltip - 1
                    : likesTooltip
                )}
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          ) : (
            <span
              className="f-icon icon-heart f-icon-heart-fixed"
              onClick={() => {
                interactDatalayer("like")
                handleLike(idArticle)
              }}
            >
              <span className="f-tooltip-heart">
                {formatNumberLikes(
                  fakeLikes
                    ? likesTooltip + 1
                    : fakeUnLikes
                    ? likesTooltip - 1
                    : likesTooltip
                )}
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          )}
          <span
            className="f-icon icon-share"
            onClick={() => {
              interactDatalayer("share")
              setShareMenu(true)
            }}
          ></span>
          {activeNotifications ? (
            <span className="f-icon icon2-notification-active f-icon-notification-fixed" />
          ) : (
            <span
              className="f-icon icon-notification f-icon-notification-fixed"
              onClick={() => {
                activateNotificationSection()
                interactDatalayer("notification")
              }}
            >
              <span className="f-tooltip-notification">
                Activa las notificaciones para recibir lo último de magazín
                <span className="f-tooltip-signal"></span>
              </span>
            </span>
          )}
        </div>
        <div
          className={
            "f-hidden-share-fixed " + (activeShareMenu && "share-hidden-active")
          }
        >
          <SharedFacebook
            href={typeof window !== "undefined" ? window.location.href : "/"}
          >
            <span className="f-icon icon-facebook"></span>
          </SharedFacebook>

          <SharedWhatsapp href={linkShared} />

          <span
            className="f-icon icon2-close f-icon-close"
            onClick={() => setShareMenu(false)}
          ></span>
        </div>
      </div>
    </div>
  )
}

export default InteractionArticleMG
